export default __webpack_public_path__ + "static/media/IRAS.3a53de62.svg";